// extracted by mini-css-extract-plugin
export default {"PropertyPrice":"PropertyPrice_PropertyPrice__0+CVu"};